<template>
  <el-menu
    class="menu"
    :default-openeds="defaultOpeneds"
    :router="true"
    :default-active="defaultActive"
    :collapse="true"
  >
    <template v-for="menu in data">
      <SubMenu v-if="!isHidden(menu)" :menu="menu" :key="menu.path" />
    </template>
    <!-- 2026-09-15 原写法：:popper-append-to-body="false"
         原因：侧栏改为内部滚动后，false 会裁切子菜单；改为 true 并挂到 body，避免弹层被 overflow 裁掉 -->
    <!-- <el-submenu index="__customer_service__" :popper-append-to-body="false"> -->
    <el-submenu index="__customer_service__" :popper-append-to-body="true" popper-class="layout-aside-submenu-popup">
      <template slot="title">{{ $t('客服') }}</template>
      <el-menu-item index="" @click="$emit('operationManual')">{{ $t('操作手册') }}</el-menu-item>
      <el-menu-item index="" @click="$emit('feedback')">{{ $t('问题反馈') }}</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
  import SubMenu from './submenu.vue'
  export default {
    name: 'Menu',
    components: { SubMenu },
    props: {
      data: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      defaultOpeneds() {
        return this.data.map((item) => item.path)
      },
      defaultActive() {
        return this.$route.path
      },
    },
    methods: {
      isHidden(menu) {
        return menu?.meta?.hidden || menu.name === 'GlobalFiledPermission'
      },
    },
  }
</script>
